import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@app/shared';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { archiveRefName } from '@entity/user-role';
import { ConfirmationService, ConfirmationDialog } from '@app/library';
import { NguAlertService } from '@app/shared';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Subscription } from 'rxjs';
import { environment } from '@env/environment.prod';
import { Router } from '@angular/router';
import { timeout } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  loading: boolean;
  message:any = '';
  defaultPage = '';
  loginForm: FormGroup;
  forgotPasswordForm: FormGroup;
  dlogData: ConfirmationDialog;
  display = 'none';
  displayBackDrop = false;

  private subscription: Subscription;
  show_login: boolean = true;

  icon: string;
  type: string;

  constructor(
    private auth: AuthService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private pop: ConfirmationService,
    private alert: NguAlertService,
    private recaptchaV3Service: ReCaptchaV3Service,
    public router: Router
  ) {
    // this.dlogData.body ='body string';
    //   //this.dlogData.buttons
    //   this.dlogData.heading = 'info';
    //   this.dlogData.type = 'info';
  }

  public ngOnInit() {
    //debugger;
    localStorage.clear();
    sessionStorage.clear();

    this.icon = 'fa-eye-slash';
    this.type = 'password';

    let activatedDomainName = this.auth.getDomainName();
    this.loginForm = this.fb.group({
      username: [activatedDomainName.includes(archiveRefName.archive) ? '' : '', Validators.required],
      password: [activatedDomainName.includes(archiveRefName.archive) ? '' : '', Validators.required],
      loginFlag: [activatedDomainName.includes(archiveRefName.archive) ? '' : '', null],
      recaptcha: ['', Validators.required]
    });

    this.forgotPasswordForm = this.fb.group({
      email: [activatedDomainName.includes(archiveRefName.archive) ? '' : '', Validators.required]
    });

    this.initalizeRecaptcha(); // google recaptch initalization

    // this.pop.confirm().then((res: any) => {});
    // this.openModalDialog();
    // console.log(this.route.snapshot['_routerState'].url);
    // let activatedRoutedUrl=this.route.snapshot['_routerState'].url;// to check whether the url comes from login or archive purpose

    this.show_login = true;
  }



  iconChange() {
    if (this.icon == 'fa-eye-slash') {
      this.icon = 'fa-eye';
      this.type = 'text';
    } else {
      this.icon = 'fa-eye-slash'
      this.type = 'password';
    }
  }

  initalizeRecaptcha() {
    this.subscription = this.recaptchaV3Service.execute("login_form")
      .subscribe((token) => {
        this.loginForm.patchValue({ recaptcha: token }); this.message = '';
      },
        (error) => {
          this.loginForm.patchValue({ recaptcha: '' }); this.message = error;
        });
  }

  public ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  openModalDialog() {
    this.display = 'block'; //Set block css
    this.displayBackDrop = true;
  }

  closeModalDialog() {
    this.display = 'none'; //set none css after close dialog
    this.displayBackDrop = false;
  }

  // forgot password
  forgotPw() {
    this.show_login = false;
  }

  onSubmit() {
    this.message = ''; this.defaultPage = ''; this.loading = true;
    this.auth.login(this.loginForm.value).then(res => {
      if (!res) {
        this.loading = false; this.message = 'Invalid Username or Password';
      }
      else if (res && res == 'DefaultPage') {
        this.loading = false;
        this.message = "Please contact administrator.";
        this.defaultPage = " Your default landing page isn't set";
      }
      else if (res && res == 'loginConfirmation') {
        this.forceLogout();
        /* const obj: ConfirmationDialog = {
          heading: 'ATTENTION!',
          body: 'Concurrent login on multiple devices is not permitted, please ensure you are logged out of any other device to continue',
          yesButton: 'Ok',
          noButton: 'Cancel'
        };
        this.pop.confirm(obj).then(isConfirmed => {
          if (isConfirmed) {
            this.forceLogout();
          }
        }); */
        this.loading = false;        
      }
      else if (res) {
        var params = {
          secret_key: environment.recaptchaSecretKey,  // Secret API key
          response: this.loginForm?.get('recaptcha')?.value   // Received token from the frontend
        };
        this.auth.recaptchaApi(params).subscribe((recaptchaRes:any) => {
          if (recaptchaRes != null && !recaptchaRes.success) {
            if (recaptchaRes["error-codes"] && recaptchaRes["error-codes"].length > 0) {
              if (recaptchaRes["error-codes"][0] === "timeout-or-duplicate")
                this.message = "Refresh screen to continue";
            }
            else this.message = "Recaptcha error";
            this.loading = false;
          }
          else
            this.router.navigate([res]);
        });
      }
    });
  }

  forgotPasswordSubmit() {
    this.auth.forgotPassowrd(this.forgotPasswordForm.value).then(res => {
      //debugger;
      this.forgotPasswordForm.reset();
      if (!res) {
        this.loading = false;
        if (sessionStorage.hasOwnProperty('message') && sessionStorage.hasOwnProperty('message') != null) {
          this.message = sessionStorage.getItem('message');
          sessionStorage.removeItem('message');
        } else {
          this.message = 'Something went wrong.. We could not send reset link now.';
        }

        setTimeout(() => {
          this.message = ''
          this.show_login = false;
        }, 5000);
      }
      else if (res) {
        this.message = 'We have emailed your password reset link!',
          setTimeout(() => {
            this.show_login = false;
            this.message = ''
          }, 5000);
      }
    });
  }

  forceLogout() {
    //debugger;
    this.auth.loginConfirmation().subscribe((confirmRes:any) => {
      if (confirmRes.Status.toLowerCase() == "success") {
        this.onSubmit();
        //this.ngOnInit();
        /* this.alert.open({
          heading: 'Successfully LoggedOut',
          msg: 'Successfully logged out from other devices',
          type: 'success'
        }); */
      }
    });
  }
}